module.exports = __webpack_public_path__ + "static/media/pencilPurple.c2b6d41d.svg";